{
  "three-acts": {
    "name": "Trzy akty",
    "summary": "Wprowadzenie, konfrontacja i rozwiązanie: układ wspólny większości powieści i filmów.",
    "bestFor": "Każdy gatunek i pierwszy szkic, który chcesz zachować w prostej formie.",
    "metaTitle": "Szablon historii w trzech aktach — Musael",
    "metaDescription": "Wprowadzenie, konfrontacja i rozwiązanie: układ większości powieści i filmów. Do każdego gatunku i prostego pierwszego szkicu.",
    "acts": [
      {
        "title": "Akt I: Wprowadzenie",
        "synopsis": "Kim jest bohater, czego chce i jakie wydarzenie kończy jego zwykłe życie.",
        "chapters": [
          {
            "title": "Zwyczajny świat",
            "synopsis": "Bohater u siebie, z pragnieniem i słabością, które historia wystawi na próbę.",
            "scenes": [
              {
                "title": "Obraz otwierający",
                "synopsis": "Migawka przedstawiająca bohatera, zanim cokolwiek się zmieni."
              },
              {
                "title": "Haczyk fabularny",
                "synopsis": "Coś drobnego, ale dziwnego, co zapowiada kłopoty."
              }
            ]
          },
          {
            "title": "Wydarzenie inicjujące",
            "synopsis": "Zdarzenie, którego bohater nie może zignorować.",
            "scenes": [
              {
                "title": "Zdarzenie inicjujące",
                "synopsis": "Problem się pojawia i nie znika."
              },
              {
                "title": "Wahanie",
                "synopsis": "Bohater się waha, a my widzimy, co może stracić."
              }
            ]
          },
          {
            "title": "Przekroczenie progu",
            "synopsis": "Bohater się angażuje; nie ma łatwej drogi powrotnej.",
            "scenes": [
              {
                "title": "Decyzja",
                "synopsis": "Bohater wybiera działanie i zostawia za sobą to, co znajome."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt II: Konfrontacja",
        "synopsis": "Bohater próbuje, ponosi porażki i uczy się, a stawka wciąż rośnie.",
        "chapters": [
          {
            "title": "Rosnąca stawka",
            "synopsis": "Nowe zasady, sojusznicy i wrogowie; pierwsze zwycięstwa mają swoją cenę.",
            "scenes": [
              {
                "title": "Pierwsza próba",
                "synopsis": "Bohater poznaje nowy świat i częściowo go błędnie odczytuje."
              },
              {
                "title": "Sojusznicy i wrogowie",
                "synopsis": "Kto pomaga, kto przeszkadza i dlaczego."
              }
            ]
          },
          {
            "title": "Punkt środkowy",
            "synopsis": "Zwrot, który zmienia to, o czym jest historia.",
            "scenes": [
              {
                "title": "Punkt środkowy",
                "synopsis": "Pozorne zwycięstwo lub pozorna porażka; bohater przestaje tylko reagować i przejmuje inicjatywę."
              }
            ]
          },
          {
            "title": "Wszystko się rozpada",
            "synopsis": "Przeciwnicy zaciskają krąg, a słabość drogo kosztuje bohatera.",
            "scenes": [
              {
                "title": "Zaciskająca się pętla",
                "synopsis": "Każdy plan napotyka opór; relacje pękają."
              },
              {
                "title": "Wszystko stracone",
                "synopsis": "Najniższy punkt: cel wydaje się na zawsze nieosiągalny."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt III: Rozwiązanie",
        "synopsis": "Bohater się zmienia, staje przed ostatnią próbą i zaczyna nową codzienność.",
        "chapters": [
          {
            "title": "Punkt kulminacyjny",
            "synopsis": "Ostateczna konfrontacja, wygrana dzięki lekcji z drugiego aktu.",
            "scenes": [
              {
                "title": "Ostateczny plan",
                "synopsis": "Bohater zbiera to, czego się nauczył, i podejmuje ostatnią próbę."
              },
              {
                "title": "Kulminacja",
                "synopsis": "Rozstrzygająca konfrontacja."
              }
            ]
          },
          {
            "title": "Nowa codzienność",
            "synopsis": "Co zmieniło się dla bohatera i dla świata.",
            "scenes": [
              {
                "title": "Obraz zamykający",
                "synopsis": "Odbicie obrazu otwierającego, pokazujące, jak daleko zaszedł bohater."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "Podróż bohatera",
    "summary": "Dwanaście etapów od wezwania do przygody po powrót do domu, zebranych w odejście, inicjację i powrót.",
    "bestFor": "Fantasy, przygody i wyprawy.",
    "metaTitle": "Szablon podróży bohatera — Musael",
    "metaDescription": "Dwanaście etapów od wezwania do przygody po powrót do domu: odejście, inicjacja i powrót. Do fantasy, przygód i wypraw.",
    "acts": [
      {
        "title": "Odejście",
        "synopsis": "Bohater opuszcza znany świat.",
        "chapters": [
          {
            "title": "Zwyczajny świat",
            "synopsis": "Bohater przed przygodą: dom, nawyki i to, czego brakuje.",
            "scenes": [
              {
                "title": "Zwyczajny świat",
                "synopsis": "Bohater przed przygodą: dom, nawyki i to, czego brakuje."
              }
            ]
          },
          {
            "title": "Wezwanie do przygody",
            "synopsis": "Wyzwanie lub wiadomość zakłóca zwyczajny świat.",
            "scenes": [
              {
                "title": "Wezwanie do przygody",
                "synopsis": "Wyzwanie lub wiadomość zakłóca zwyczajny świat."
              }
            ]
          },
          {
            "title": "Odrzucenie wezwania",
            "synopsis": "Strach lub obowiązek powstrzymuje bohatera.",
            "scenes": [
              {
                "title": "Odrzucenie wezwania",
                "synopsis": "Strach lub obowiązek powstrzymuje bohatera."
              }
            ]
          },
          {
            "title": "Spotkanie z mentorem",
            "synopsis": "Ktoś udziela rady, szkoli lub wręcza dar.",
            "scenes": [
              {
                "title": "Spotkanie z mentorem",
                "synopsis": "Ktoś udziela rady, szkoli lub wręcza dar."
              }
            ]
          },
          {
            "title": "Przekroczenie pierwszego progu",
            "synopsis": "Bohater wkracza do niezwykłego świata.",
            "scenes": [
              {
                "title": "Przekroczenie pierwszego progu",
                "synopsis": "Bohater wkracza do niezwykłego świata."
              }
            ]
          }
        ]
      },
      {
        "title": "Inicjacja",
        "synopsis": "Próby w niezwykłym świecie i wielkie wyzwanie.",
        "chapters": [
          {
            "title": "Próby, sojusznicy i wrogowie",
            "synopsis": "Bohater poznaje zasady nowego świata.",
            "scenes": [
              {
                "title": "Próby, sojusznicy i wrogowie",
                "synopsis": "Bohater poznaje zasady nowego świata."
              }
            ]
          },
          {
            "title": "Zbliżenie do najgłębszej jaskini",
            "synopsis": "Przygotowania do głównego niebezpieczeństwa.",
            "scenes": [
              {
                "title": "Zbliżenie do najgłębszej jaskini",
                "synopsis": "Przygotowania do głównego niebezpieczeństwa."
              }
            ]
          },
          {
            "title": "Wielka próba",
            "synopsis": "Kryzys życia i śmierci; coś w bohaterze umiera.",
            "scenes": [
              {
                "title": "Wielka próba",
                "synopsis": "Kryzys życia i śmierci; coś w bohaterze umiera."
              }
            ]
          },
          {
            "title": "Nagroda",
            "synopsis": "Bohater zdobywa skarb, wiedzę lub pojednanie.",
            "scenes": [
              {
                "title": "Nagroda",
                "synopsis": "Bohater zdobywa skarb, wiedzę lub pojednanie."
              }
            ]
          }
        ]
      },
      {
        "title": "Powrót",
        "synopsis": "Droga do domu, ostatnia próba i to, co bohater przynosi ze sobą.",
        "chapters": [
          {
            "title": "Droga powrotna",
            "synopsis": "Bohater rusza do domu, często ścigany.",
            "scenes": [
              {
                "title": "Droga powrotna",
                "synopsis": "Bohater rusza do domu, często ścigany."
              }
            ]
          },
          {
            "title": "Odrodzenie",
            "synopsis": "Ostatnia próba, w której wykorzystuje wszystko, czego się nauczył.",
            "scenes": [
              {
                "title": "Odrodzenie",
                "synopsis": "Ostatnia próba, w której wykorzystuje wszystko, czego się nauczył."
              }
            ]
          },
          {
            "title": "Powrót z eliksirem",
            "synopsis": "Bohater wraca odmieniony, mając czym się podzielić.",
            "scenes": [
              {
                "title": "Powrót z eliksirem",
                "synopsis": "Bohater wraca odmieniony, mając czym się podzielić."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "Plan w piętnastu punktach",
    "summary": "Schemat scenarzystów: piętnaście zwrotów rozłożonych na trzy akty.",
    "bestFor": "Zwarte, komercyjne fabuły z wyraźnymi punktami zwrotnymi.",
    "metaTitle": "Szablon historii w piętnastu punktach — Musael",
    "metaDescription": "Schemat scenarzystów: piętnaście zwrotów w trzech aktach. Do zwartych, komercyjnych fabuł z wyraźnymi punktami zwrotnymi.",
    "acts": [
      {
        "title": "Akt I",
        "synopsis": "Dawny świat i wybór, by go opuścić.",
        "chapters": [
          {
            "title": "Obraz otwierający",
            "synopsis": "Bohater i świat przed rozpoczęciem historii.",
            "scenes": [
              {
                "title": "Obraz otwierający",
                "synopsis": "Bohater i świat przed rozpoczęciem historii."
              }
            ]
          },
          {
            "title": "Nazwanie tematu",
            "synopsis": "Ktoś mówi, o czym naprawdę jest historia; bohater jeszcze tego nie dostrzega.",
            "scenes": [
              {
                "title": "Nazwanie tematu",
                "synopsis": "Ktoś mówi, o czym naprawdę jest historia; bohater jeszcze tego nie dostrzega."
              }
            ]
          },
          {
            "title": "Wprowadzenie",
            "synopsis": "Życie bohatera, obecni w nim ludzie i to, co wymaga naprawy.",
            "scenes": [
              {
                "title": "Wprowadzenie",
                "synopsis": "Życie bohatera, obecni w nim ludzie i to, co wymaga naprawy."
              }
            ]
          },
          {
            "title": "Katalizator",
            "synopsis": "Zdarzenie, które wprawia historię w ruch.",
            "scenes": [
              {
                "title": "Katalizator",
                "synopsis": "Zdarzenie, które wprawia historię w ruch."
              }
            ]
          },
          {
            "title": "Wahanie",
            "synopsis": "Bohater nie wie, co zrobić.",
            "scenes": [
              {
                "title": "Wahanie",
                "synopsis": "Bohater nie wie, co zrobić."
              }
            ]
          },
          {
            "title": "Wejście w drugi akt",
            "synopsis": "Bohater wybiera nową drogę.",
            "scenes": [
              {
                "title": "Wejście w drugi akt",
                "synopsis": "Bohater wybiera nową drogę."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt II",
        "synopsis": "Spełnienie obietnicy pomysłu, a potem upadek.",
        "chapters": [
          {
            "title": "Wątek poboczny",
            "synopsis": "Drugi wątek, często relacja, który niesie temat historii.",
            "scenes": [
              {
                "title": "Wątek poboczny",
                "synopsis": "Drugi wątek, często relacja, który niesie temat historii."
              }
            ]
          },
          {
            "title": "Zabawa i gry",
            "synopsis": "Pomysł się urzeczywistnia: to, po co przyszli czytelnicy.",
            "scenes": [
              {
                "title": "Zabawa i gry",
                "synopsis": "Pomysł się urzeczywistnia: to, po co przyszli czytelnicy."
              }
            ]
          },
          {
            "title": "Punkt środkowy",
            "synopsis": "Pozorne zwycięstwo lub porażka podnosi stawkę.",
            "scenes": [
              {
                "title": "Punkt środkowy",
                "synopsis": "Pozorne zwycięstwo lub porażka podnosi stawkę."
              }
            ]
          },
          {
            "title": "Przeciwnicy się zbliżają",
            "synopsis": "Wątpliwości wewnątrz, presja z zewnątrz.",
            "scenes": [
              {
                "title": "Przeciwnicy się zbliżają",
                "synopsis": "Wątpliwości wewnątrz, presja z zewnątrz."
              }
            ]
          },
          {
            "title": "Wszystko stracone",
            "synopsis": "Przeciwieństwo punktu środkowego: najgorsza chwila.",
            "scenes": [
              {
                "title": "Wszystko stracone",
                "synopsis": "Przeciwieństwo punktu środkowego: najgorsza chwila."
              }
            ]
          },
          {
            "title": "Ciemna noc duszy",
            "synopsis": "Bohater opłakuje stratę i odnajduje lekcję.",
            "scenes": [
              {
                "title": "Ciemna noc duszy",
                "synopsis": "Bohater opłakuje stratę i odnajduje lekcję."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt III",
        "synopsis": "Lekcja wprowadzona w życie.",
        "chapters": [
          {
            "title": "Wejście w trzeci akt",
            "synopsis": "Nowy pomysł z wątku pobocznego otwiera drogę.",
            "scenes": [
              {
                "title": "Wejście w trzeci akt",
                "synopsis": "Nowy pomysł z wątku pobocznego otwiera drogę."
              }
            ]
          },
          {
            "title": "Finał",
            "synopsis": "Bohater naprawia to, co było zepsute, sam trwale odmieniony.",
            "scenes": [
              {
                "title": "Finał",
                "synopsis": "Bohater naprawia to, co było zepsute, sam trwale odmieniony."
              }
            ]
          },
          {
            "title": "Obraz końcowy",
            "synopsis": "Świat po wszystkim, odbijający obraz otwierający.",
            "scenes": [
              {
                "title": "Obraz końcowy",
                "synopsis": "Świat po wszystkim, odbijający obraz otwierający."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "Struktura siedmiopunktowa",
    "summary": "Planuj wstecz od zakończenia: haczyk, zwroty, naciski, punkt środkowy i rozwiązanie.",
    "bestFor": "Autorzy, którzy najpierw znają zakończenie.",
    "metaTitle": "Siedmiopunktowy szablon historii — Musael",
    "metaDescription": "Planuj wstecz od zakończenia: haczyk, zwroty, naciski, punkt środkowy i rozwiązanie. Dla autorów, którzy najpierw znają finał.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Haczyk",
            "synopsis": "Stan początkowy, przeciwieństwo rozwiązania.",
            "scenes": [
              {
                "title": "Haczyk",
                "synopsis": "Stan początkowy, przeciwieństwo rozwiązania."
              }
            ]
          },
          {
            "title": "Zwrot fabularny 1",
            "synopsis": "Zaczyna się konflikt, a bohater zostaje zmuszony do działania.",
            "scenes": [
              {
                "title": "Zwrot fabularny 1",
                "synopsis": "Zaczyna się konflikt, a bohater zostaje zmuszony do działania."
              }
            ]
          },
          {
            "title": "Nacisk 1",
            "synopsis": "Antagonista wywiera presję; bohater musi działać.",
            "scenes": [
              {
                "title": "Nacisk 1",
                "synopsis": "Antagonista wywiera presję; bohater musi działać."
              }
            ]
          },
          {
            "title": "Punkt środkowy",
            "synopsis": "Bohater przechodzi od reagowania do działania.",
            "scenes": [
              {
                "title": "Punkt środkowy",
                "synopsis": "Bohater przechodzi od reagowania do działania."
              }
            ]
          },
          {
            "title": "Nacisk 2",
            "synopsis": "Sprawy idą bardzo źle; plan zawodzi.",
            "scenes": [
              {
                "title": "Nacisk 2",
                "synopsis": "Sprawy idą bardzo źle; plan zawodzi."
              }
            ]
          },
          {
            "title": "Zwrot fabularny 2",
            "synopsis": "Bohater zdobywa ostatni element potrzebny do zwycięstwa.",
            "scenes": [
              {
                "title": "Zwrot fabularny 2",
                "synopsis": "Bohater zdobywa ostatni element potrzebny do zwycięstwa."
              }
            ]
          },
          {
            "title": "Rozwiązanie",
            "synopsis": "Stan końcowy, odpowiedź na haczyk.",
            "scenes": [
              {
                "title": "Rozwiązanie",
                "synopsis": "Stan końcowy, odpowiedź na haczyk."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "Kishōtenketsu",
    "summary": "Cztery części zbudowane wokół zwrotu zamiast konfliktu.",
    "bestFor": "Proza literacka, opowiadania i spokojne książki skupione na postaciach.",
    "metaTitle": "Szablon narracyjny Kishōtenketsu — Musael",
    "metaDescription": "Cztery części oparte na zwrocie zamiast konfliktu. Do prozy literackiej, opowiadań i spokojnych książek skupionych na postaciach.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Ki: wprowadzenie",
            "synopsis": "Postacie i ich świat, przedstawione spokojnie.",
            "scenes": [
              {
                "title": "Wprowadzenie",
                "synopsis": "Kto, gdzie i jak wygląda codzienność."
              }
            ]
          },
          {
            "title": "Shō: rozwinięcie",
            "synopsis": "Sytuacja się pogłębia, jeszcze bez zwrotu.",
            "scenes": [
              {
                "title": "Rozwinięcie",
                "synopsis": "Lepiej poznajemy postacie; drobne rzeczy się zmieniają."
              }
            ]
          },
          {
            "title": "Ten: zwrot",
            "synopsis": "Nieoczekiwany element zmienia sposób, w jaki widzimy całość.",
            "scenes": [
              {
                "title": "Zwrot",
                "synopsis": "Pojawia się coś nowego, pozornie niezwiązanego z resztą."
              }
            ]
          },
          {
            "title": "Ketsu: połączenie",
            "synopsis": "Części łączą się w nowe zrozumienie.",
            "scenes": [
              {
                "title": "Połączenie",
                "synopsis": "Zwrot spotyka się z historią; znaczenie się zmienia."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "Kryminał",
    "summary": "Zbrodnia, śledztwo pośród wskazówek i fałszywych tropów oraz uczciwe wobec czytelnika rozwiązanie.",
    "bestFor": "Kryminały, powieści detektywistyczne i przytulne kryminały.",
    "metaTitle": "Szablon historii kryminalnej — Musael",
    "metaDescription": "Zbrodnia, wskazówki, fałszywe tropy i uczciwe rozwiązanie. Do kryminałów, powieści detektywistycznych i przytulnych kryminałów.",
    "acts": [
      {
        "title": "Zbrodnia",
        "synopsis": "Coś jest nie tak i ktoś musi odkryć dlaczego.",
        "chapters": [
          {
            "title": "Odkrycie",
            "synopsis": "Zbrodnia lub zaginięcie.",
            "scenes": [
              {
                "title": "Ciało",
                "synopsis": "Zbrodnia zostaje odkryta; pierwsze wrażenia i pytania."
              },
              {
                "title": "Detektyw",
                "synopsis": "Kto prowadzi śledztwo i dlaczego to dla niego ważne."
              }
            ]
          }
        ]
      },
      {
        "title": "Śledztwo",
        "synopsis": "Wskazówki, podejrzani i fałszywe tropy.",
        "chapters": [
          {
            "title": "Podejrzani",
            "synopsis": "Wszyscy z motywem i alibi.",
            "scenes": [
              {
                "title": "Rozmowy",
                "synopsis": "Każdy podejrzany dostaje powód, by kłamać."
              },
              {
                "title": "Pierwsza wskazówka",
                "synopsis": "Fakt, który będzie ważny później; graj uczciwie z czytelnikiem."
              }
            ]
          },
          {
            "title": "Fałszywe tropy",
            "synopsis": "Śledztwo zmierza w złą stronę.",
            "scenes": [
              {
                "title": "Mylący trop",
                "synopsis": "Dowody wskazują niewłaściwą osobę."
              },
              {
                "title": "Eskalacja",
                "synopsis": "Kolejna zbrodnia lub groźba podnosi stawkę."
              }
            ]
          },
          {
            "title": "Ukryta prawda",
            "synopsis": "Detektyw dostrzega to, co było tam od początku.",
            "scenes": [
              {
                "title": "Brakujący element",
                "synopsis": "Drobny szczegół sprawia, że wcześniejsze wskazówki pasują do siebie."
              }
            ]
          }
        ]
      },
      {
        "title": "Ujawnienie prawdy",
        "synopsis": "Rozwiązanie i jego cena.",
        "chapters": [
          {
            "title": "Wyjaśnienie",
            "synopsis": "Każda wskazówka zostaje wyjaśniona.",
            "scenes": [
              {
                "title": "Ujawnienie prawdy",
                "synopsis": "Sprawca zostaje wskazany, a tok rozumowania przedstawiony."
              },
              {
                "title": "Następstwa",
                "synopsis": "Sprawiedliwość lub jej brak i to, co detektyw wynosi ze sprawy."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "Romans",
    "summary": "Dwie osoby, to, co je rozdziela, i to, czego potrzebują, by wybrać siebie nawzajem.",
    "bestFor": "Romanse i historie miłosne w dowolnych realiach.",
    "metaTitle": "Szablon historii miłosnej — Musael",
    "metaDescription": "Dwie osoby, to, co je rozdziela, i droga do wyboru siebie nawzajem. Do romansów i historii miłosnych w dowolnych realiach.",
    "acts": [
      {
        "title": "Zakochiwanie się",
        "synopsis": "Spotykają się, opierają uczuciu i zaczynają się zakochiwać.",
        "chapters": [
          {
            "title": "Spotkanie",
            "synopsis": "Pierwsze spotkanie, iskra i przeszkoda.",
            "scenes": [
              {
                "title": "Poznanie",
                "synopsis": "Dwoje bohaterów się spotyka; coś w drugiej osobie porusza ich do głębi."
              },
              {
                "title": "Opór",
                "synopsis": "Dlaczego to nie może się udać: cele, rany lub okoliczności."
              }
            ]
          },
          {
            "title": "Zbliżenie",
            "synopsis": "Zmuszeni do bycia razem, widzą siebie takimi, jacy są.",
            "scenes": [
              {
                "title": "Razem przez przypadek",
                "synopsis": "Sytuacja trzyma ich blisko siebie."
              },
              {
                "title": "Pierwsza prawdziwa chwila",
                "synopsis": "Przebłysk tego, kim naprawdę jest druga osoba."
              }
            ]
          }
        ]
      },
      {
        "title": "Wątpliwości",
        "synopsis": "Zaangażowanie, a potem strach, który je niszczy.",
        "chapters": [
          {
            "title": "Punkt środkowy",
            "synopsis": "Poddają się swoim uczuciom.",
            "scenes": [
              {
                "title": "Zaangażowanie",
                "synopsis": "Pocałunek, wyznanie lub obietnica."
              }
            ]
          },
          {
            "title": "Pęknięcie",
            "synopsis": "Dawna rana lub zewnętrzna przeszkoda na razie wygrywa.",
            "scenes": [
              {
                "title": "Zwątpienie",
                "synopsis": "Wracają dawne lęki."
              },
              {
                "title": "Rozstanie",
                "synopsis": "Odchodzą, każde przekonane o swojej racji."
              }
            ]
          }
        ]
      },
      {
        "title": "Wybór",
        "synopsis": "Rozwój, wielki gest i wspólna przyszłość.",
        "chapters": [
          {
            "title": "Razem",
            "synopsis": "Każde zmienia się na tyle, by zasłużyć na drugą osobę.",
            "scenes": [
              {
                "title": "Wielki gest",
                "synopsis": "Jedno z nich ryzykuje wszystko, by pokazać, że się zmieniło."
              },
              {
                "title": "Długo i szczęśliwie",
                "synopsis": "Albo na razie szczęśliwie: przyszłość, którą wybierają."
              }
            ]
          }
        ]
      }
    ]
  }
}
